import { render, staticRenderFns } from "./CreatedKeyword.vue?vue&type=template&id=3975c84c&scoped=true&"
import script from "./CreatedKeyword.vue?vue&type=script&lang=js&"
export * from "./CreatedKeyword.vue?vue&type=script&lang=js&"
import style0 from "./CreatedKeyword.vue?vue&type=style&index=0&id=3975c84c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3975c84c",
  null
  
)

export default component.exports